import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {RetweetOutlined} from '@ant-design/icons';
import general from "../../general";
import $ from "jquery";
import {useLockFn, useScroll, useUpdateEffect} from "ahooks";
import Dialog from "../../lib/Dialog";
import Image from "../../lib/Image";

export default props => {
  useEffect(() => {
    props.setOperate(<Link to="/recovery/record" className="recovery-record">回收记录</Link>);
  }, []);
  const [loaded, setLoaded] = useState(false);
  const [page, setPage] = useState(1);
  const [datas, setDatas] = useState([]);
  const [more, setMore] = useState(true);
  const [notice, setNotice] = useState(); //回收须知
  const [waring, setWaring] = useState(); //温馨提示

  // const [init, setInit] = useState(false);
  const load = useLockFn(async (parms = {}) => {
    Dialog.loading();
    let tmp = {
      pagination: {page: page, count: 20},
    };
    if (parms.page) {
      tmp.pagination.page = parms.page;
    }
    await general.axios.post('/recyclableAltGames', tmp)
        .finally(() => {
          Dialog.close();
        })
        .then(res => {
          let {status, data: {info, list, paginated}} = res.data;
          if (!status.succeed) {
            Dialog.error(status.error_desc);
          } else {
            setLoaded(true);
            if (parms.page) {
              setPage(parms.page);
            }

            let notice = info.notice;
            setNotice(notice);
            let waring = info.waring;
            setWaring(waring);

            setDatas(datas => parms.page === 1 || !parms.page ? list : [...datas, ...list]);
            setMore(paginated.more && list.length > 0);
          }
        })
        .catch(err => {
          Dialog.error(err.message);
        });
  });
  useEffect(() => {
    if (props.active) {
      load({page: 1});
    }
  }, [props.active]);

  const scroll = useScroll();
  useUpdateEffect(() => {
    if (props.active) {
      if (scroll.top < -80) {
        load({page: 1});
      }
      if (scroll.top + window.innerHeight + 20 > $(document).height() && more) {
        load({page: page + 1});
      }
    }
  }, [scroll, props.active]);

  return <div className="recovery-index">
    <div className="recovery-step">
      <div className="item"><div className="icon"><img src="/resources/recovery/recovery-one.png" /></div><div>选择小号</div></div>
      <div className="icon-step"><img src="/resources/recovery/recovery-four.png" /></div>
      <div className="item"><div className="icon"><img src="/resources/recovery/recovery-two.png" /></div><div>确认提交</div></div>
      <div className="icon-step"><img src="/resources/recovery/recovery-four.png" /></div>
      <div className="item"><div className="icon"><img src="/resources/recovery/recovery-three.png" /></div><div>实时到账</div></div>
    </div>
    <div className="recovery-explain">
      <div className="title">回收须知</div>
      <div className="desc">
        {
          notice?.map((item, index) => <div className="item">
            {item}
          </div>)
        }
        {/* <div className="item">累计充值满100元以上小号，可按实际充值5%金额回收金币，充值仅计算2019. 09之后小号充值部分，金币／代金券充值不计算在内。（关服超过三个月及游戏下架超过六个月的小号不支持回收）</div>
        <div className="item">购买的小号进行回收仅计算购买后充值金额，回收后72小时内可赎回，逾期不可赎回。</div>
        <div className="item">
        赎回小号仅支持现金赎回，需额外支付该小号充值金额的3%作为赎回手续费；赎回后可直接选择相应的小号登录游戏！（例：若小号充值满100元，回收后获得50金币。若用户需要赎回，则需支付5+3=8元）
        </div>
        <div className="item">小号回收成功后，该小号在本游戏中所有区服的角色会一同售出</div>
        <div className="item">如有任何疑问，可联系客服咨询！</div> */}
      </div>
    </div>
    <div className="recovery-tips">
      <div className="title">温馨提示</div>
      <div className="desc">
        {waring}
        {/* {waring?.map((item, index) => <div className="item">{item}</div>)} */}
        {/* <div className="item">仅支持现金赎回，回收后，请手动退出游戏，切勿再往这个角色充值， 造成损失概不负责！</div>
        <div className="item">赎回后，可直接选择相应的小号登陆游戏！</div> */}
      </div>
    </div>
    <div className="recovery-title">
      {/* <RetweetOutlined className="icon"/> */}
    可回收小号</div>
    <div className="recovery-items">
      {datas.map(item => <Link to={'/recovery/select?id=' + item.id} className="item" onClick={() => {
        general.game = {img: item.img};
      }}>
        <div className="icon"><Image src={item.img.thumb} alt=""/></div>
        <div className="info">
          <div className="name">
            {/* {item.name} */}
            <div className={" " + (item.nameRemark ? " name-new" : "")}>
              {item.name}
            </div>
            {item.nameRemark != '' ? <div className="nameRemark-new">{item.nameRemark}</div> : null}
          </div>
          {/* {
            item.nameRemark ?
            <div className="nameRemark">
              {item?.nameRemark}
            </div>
            : null
          } */}
          <div className="desc">可回收小号：<span>{item.recyclable}个</span> <div className="price"><span>{item.recyclableCoin}金币</span>（回收可得）</div></div>
          <div className="desc">历史累计充值：<span>{item.rechargedAmount}元</span></div>
        </div>
        {/* <div className="price"><span>{item.recyclableCoin}金币</span>（回收可得）</div> */}
      </Link>)}
    </div>
    {datas.length === 0 && loaded ? <div className="recovery-empty"><img src="/resources/recovery/empty.png" alt=""/>暂无可回收小号</div> : null}
  </div>;
};